import { render, staticRenderFns } from "./CooperationSchool.vue?vue&type=template&id=66dec6d2&scoped=true"
import script from "./CooperationSchool.vue?vue&type=script&lang=js"
export * from "./CooperationSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dec6d2",
  null
  
)

export default component.exports